import { render, staticRenderFns } from "./ServicesRegistryNewForm.vue?vue&type=template&id=555156e2"
import script from "./ServicesRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./ServicesRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports